"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var Eyedrop = /** @class */ (function (_super) {
    __extends(Eyedrop, _super);
    function Eyedrop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvas = null;
        _this.pixel = null;
        _this.magnifierGlassStyle = {};
        _this.magnifierColorStyle = {};
        _this.mouseOver = false;
        return _this;
    }
    Eyedrop.prototype.onImageSourceUpdate = function (newImageSource) {
        this.createCanvas(newImageSource);
        this.createMagnifyingGlass(newImageSource);
    };
    Object.defineProperty(Eyedrop.prototype, "colorPickerStyle", {
        get: function () {
            return {
                width: this.width,
                height: this.height,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Eyedrop.prototype, "label", {
        get: function () {
            if (this.pixel) {
                var r = this.pixel[0];
                var g = this.pixel[1];
                var b = this.pixel[2];
                return "r:" + r + " g:" + g + " b:" + b + " " + RGBToHex(r, g, b);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Eyedrop.prototype, "showMagnifierColor", {
        get: function () {
            return this.pixel && this.colorLabel && this.mouseOver;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Eyedrop.prototype, "showMagnifierGlass", {
        get: function () {
            return !!this.canvas && this.mouseOver;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Eyedrop.prototype, "magnifierColorSquareStyle", {
        get: function () {
            if (this.pixel) {
                return {
                    backgroundColor: "rgb(" + this.pixel[0] + "," + this.pixel[1] + "," + this.pixel[2] + ")",
                };
            }
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Eyedrop.prototype.mouseleave = function (event) {
        this.mouseOver = false;
    };
    Eyedrop.prototype.mousemove = function (event) {
        this.mouseOver = true;
        if (this.canvas) {
            this.pixel = this.canvas.getContext('2d').getImageData(event.offsetX, event.offsetY, 1, 1).data;
            this.$emit('color-update', { r: this.pixel[0], g: this.pixel[1], b: this.pixel[2] });
            vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'left', event.pageX - (this.magnifierGlassWidth / 2) + "px");
            vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'top', event.pageY - (this.magnifierGlassHeight / 2) + "px");
            vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'width', this.magnifierGlassWidth + "px");
            vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'height', this.magnifierGlassHeight + "px");
            vue_property_decorator_1.Vue.set(this.magnifierColorStyle, 'left', event.pageX - (this.magnifierGlassWidth / 2) - 100 + "px");
            vue_property_decorator_1.Vue.set(this.magnifierColorStyle, 'top', event.pageY + (this.magnifierGlassHeight / 2) + 5 + "px");
            vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'backgroundPosition', 0 - ((event.offsetX * this.zoom) - (this.magnifierGlassWidth / 2)) + "px " + (0 - ((event.offsetY * this.zoom) - (this.magnifierGlassHeight / 2))) + "px");
        }
    };
    Eyedrop.prototype.createCanvas = function (imageSource) {
        var _this = this;
        var canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        var context = canvas.getContext('2d');
        var img = new Image();
        img.src = imageSource;
        img.onload = function () {
            context.drawImage(img, 0, 0, _this.width, _this.height);
        };
        this.canvas = canvas;
    };
    Eyedrop.prototype.createMagnifyingGlass = function (imageSource) {
        vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'backgroundImage', "url('" + imageSource + "')");
        vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'backgroundRepeat', 'no-repeat');
        vue_property_decorator_1.Vue.set(this.magnifierGlassStyle, 'backgroundSize', this.width * this.zoom + "px " + this.height * this.zoom + "px");
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: 4, type: Number })
    ], Eyedrop.prototype, "zoom", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: 100, type: Number })
    ], Eyedrop.prototype, "magnifierGlassWidth", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: 100, type: Number })
    ], Eyedrop.prototype, "magnifierGlassHeight", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false, type: Boolean })
    ], Eyedrop.prototype, "colorLabel", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true, type: String })
    ], Eyedrop.prototype, "src", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true, type: Number })
    ], Eyedrop.prototype, "width", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true, type: Number })
    ], Eyedrop.prototype, "height", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true, type: String })
    ], Eyedrop.prototype, "alt", void 0);
    __decorate([
        vue_property_decorator_1.Watch('src', { immediate: true })
    ], Eyedrop.prototype, "onImageSourceUpdate", null);
    Eyedrop = __decorate([
        vue_property_decorator_1.Component
    ], Eyedrop);
    return Eyedrop;
}(vue_property_decorator_1.Vue));
exports.default = Eyedrop;
function RGBToHex(r, g, b) {
    var rString = r.toString(16);
    var gString = g.toString(16);
    var bString = b.toString(16);
    if (rString.length === 1) {
        rString = '0' + rString;
    }
    if (gString.length === 1) {
        gString = '0' + gString;
    }
    if (bString.length === 1) {
        bString = '0' + bString;
    }
    return '#' + rString + gString + bString;
}
